import { render, staticRenderFns } from "./changeAddressDialog.vue?vue&type=template&id=540eb4a2&"
import script from "./changeAddressDialog.vue?vue&type=script&lang=js&"
export * from "./changeAddressDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('540eb4a2')) {
      api.createRecord('540eb4a2', component.options)
    } else {
      api.reload('540eb4a2', component.options)
    }
    module.hot.accept("./changeAddressDialog.vue?vue&type=template&id=540eb4a2&", function () {
      api.rerender('540eb4a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/order/address/changeAddressDialog.vue"
export default component.exports